var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4488 12.9844L15.5222 8.06494L8.16992 15.6327L12.9944 20.4577L12.9949 20.4572C13.4843 20.9469 14.0654 21.3351 14.7051 21.5998C15.3448 21.8644 16.0304 22.0002 16.7227 21.9994C19.6372 21.9994 22.0005 19.6361 22.0005 16.7216C22.0013 16.0271 21.8646 15.3393 21.5983 14.6979C21.332 14.0564 20.9413 13.4741 20.4488 12.9844Z",
    fill: "#7AD7B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.846 3.39562C9.87519 2.49757 8.60123 1.99898 7.27876 1.99951C5.879 1.99951 4.53658 2.55556 3.5468 3.54534C2.55703 4.53511 2.00098 5.87754 2.00098 7.27729C2.00098 8.65452 2.5332 9.90507 3.39764 10.8445L3.38987 10.8523L8.17042 15.6329L15.5227 8.06507L10.846 3.39562Z",
    fill: "#FFE457"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPill);
export default __webpack_public_path__ + "static/media/icon_pill.e60a772ac8972a646ed2e562069c2e76.svg";
export { ForwardRef as ReactComponent };